import { render, staticRenderFns } from "./tenant_menu_action__form.vue?vue&type=template&id=75a9bedd"
import script from "./tenant_menu_action__form.vue?vue&type=script&lang=js"
export * from "./tenant_menu_action__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports